import {
    FETCH_GDPR_REVOKE_CONSENT,
    FETCH_GDPR_REVOKE_CONSENT_SUCCESS,
    FETCH_GDPR_REVOKE_CONSENT_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    revokeConsents: {},
    revokeConsentSuccess: true
};

const fetchGdprRevokeConsentSuccess = (isSuccess) => (state, action) => {
    return {
        isFetching: false,
        revokeConsents: { ...state.revokeConsents, [action.key]: action.revokeConsent },
        revokeConsentSuccess: isSuccess
    };
};

const handlers = {
    [FETCH_GDPR_REVOKE_CONSENT_SUCCESS]: fetchGdprRevokeConsentSuccess(true),
    [FETCH_GDPR_REVOKE_CONSENT_FAIL]: fetchGdprRevokeConsentSuccess(false)
};

export default function GdprRevokeConsent(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// clientIndicator is a boolean to indicate if the user was presented with the password checkpoint or not
export function fetchGdprRevokeConsent(key, locale, consentVersion, clientIndicator, passwordChallengeToken, callback) {
    return {
        type: FETCH_GDPR_REVOKE_CONSENT,
        key,
        locale,
        consentVersion,
        clientIndicator,
        passwordChallengeToken,
        isFetching: true,
        callback
    };
}

export const getGdprRevokeConsent = (state, key) => {
    return state.gdprRevokeConsent.revokeConsents[key];
};

export const getGdprRevokeConsentState = (state) => {
    return state.gdprRevokeConsent.revokeConsentSuccess;
};
